var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#4B9BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAE3ElEQVR4nO2dS2hdRRjHf0ma1PpICChaSUTpw+KjXajF+qCVimJrECqCbhRBRDfarSK4UFGxCLX4XLhwVdz5itYHuNFFLFVb6iO0arFgG6W2iU0ftomLL+K1zb0zc2bOmTl3vh/8dzP3fOf/nbnzuDPngqIoiqIoiqIoudERO4AWdACXAVcCCxp0PjAPOGdGABMzOgLsB3Y3aDvwPTBdYezWpJaAZcAa4HrgOqA/0OceAL4EvgCGkaQoMywFngFGkae0Cv0IPI20rizpBIaAT6jO9GbaCtwLzCn1jhNhDvAwsIf4xp+qX4CHaONE3AzsIL7RJv0A3EV6/WNhLgE+I76xrvoUuDi8HdXRATwIjBPfzKI6DDxKDVtDH/A+8Q0MpXeB3qAOlchCYCfxTQutUWBJQJ9KYRUy6YltVlk6MHOPSbIS+Iv4JpWtw8iILiluBSaJb05VOgrcHsS5AFyLLILFNqVqTQLLA/jnxYXAXuKbEUu/AYPeLhbkLGCbIcActBVZHq+cVwsE2656ydNLZ1YDUwECbxdNAbd4OepAL2muZsbWT8DZrmZ2uVYAniShIVhC9AMngM/LvMh88phsFdUEcIGLoa4tYAOwwrFOTvQgI6Jh2wouy6znImP+uY5B5cZxZG4wZlO40+GDH0DNt6EHuM+2sG0L6AR2Ib9uKWZ2A4uR4WlLbFvAStR8FxYAN9gUtE3A2uKxZMsam0K2CbjNI5BcsUqATR9wETLzVdwZREaOTbFpAVeHiSVLrjIVsEnA5QECyRWjd5qAcgmSgIUBAmnkA2AA6X8aNQh8WIP6LiwO8SG7CLtgNdDiWoM1qO+i0RbXAuxGQWPAeRblbDFdczrx+i6MISd6mmLzFVSbLXkJ0mcq4LIYp7hjbE02CTgUIJBcMXpnk4CDAQJpxNQJpl7fhSAP7whhRwbDzG7Cv8PA1Ou7aGSW6zizOXBQOWmzyVybr6AdFmWU2dlpKmCTAD3UXJwgCfgmQCC5EiQBvwLf+ceSHfuxWIqwnYi95xdLlmxBOuKWaALKY4tNIdttKV3Az0Q8jFAzTiLbOH83FbRtASeBl30iyoyPsTDflX50Y66t1hX02MhrCdxc6toHdBc12MQAck429k2mrGddDHXdnj6ObD5d5VgvFyaBu5GHtDTmoUeUmmmDh69OrEUP6Z2qSRxPx/iysYSbqLOe8rPTnbnA1wECbwftQQ6uV84iZOtFbANi6w5fI31YTt4TtHf8LfRnNXCM+GZUrTEq7nhbMURe7wyaBu4M4lxAbgT+JL4xVeiNQJ4FZyntP1H7CjgjlGFl0Ae8TXyjytAf1OTEaAewnvbqnI8DN4U0qQoWAR8R3zxfTeFwAj5Fhqh33/B4eEuq50zgEeqXiE1lmBGTbuB+4Fvim2vS69Tw5d0uLANeIM3XX75JRodYupCXwD6G7CqI/dPnK1RgfspNqwe4AjnquQS4FBl/9/LfX1j1Icsfx5AZ+FHkr698eR55EKYDfFZ2+Dz1J5C5i+JBUfMniLyu3y4UMX8vFi/WUOxwNX8E2cepBMLF/LeQyaESEBvjx4F7YgXY7pjM34YsECol0cz4v4HnkPmFUiL7ON387cA1MYPKiRf5/9j+CUrcLu5LyksRRelGdit0Im/H0peNKIqiKIpyOv8AEZcceoQv5OwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.be90595a78f61e03dedd4d08d124e607.svg";
export { ForwardRef as ReactComponent };